// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"fc73723c","561":"813ec36e","617":"8841f7d9"}[chunkId] + ".chunk.css";
};